/* ============================================
   NIGHAT APPAREL - CUSTOM JAVASCRIPT V2
   Fixed: No custom cursor, smooth performance
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  
  /* ============================================
     1. LOADING SCREEN
     ============================================ */
  function hideLoader() {
    const loader = document.querySelector('.nighat-loader');
    if (loader) {
      loader.classList.add('hidden');
      setTimeout(() => {
        loader.style.display = 'none';
      }, 700);
    }
  }
  
  // Hide when fully loaded
  window.addEventListener('load', function() {
    setTimeout(hideLoader, 800);
  });
  
  // Safety: force hide after 3 seconds (if load event fails)
  setTimeout(hideLoader, 3000);
  
  
  /* ============================================
     2. SCROLL FADE-IN ANIMATIONS
     ============================================ */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  };
  
  const scrollObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        scrollObserver.unobserve(entry.target); // Animate once
      }
    });
  }, observerOptions);
  
  // Observe sections and cards
  document.querySelectorAll('section > div, .collection-card, .product-card-v2, .feature-card, .blog-card, .testimonial-card-v2').forEach(function(el) {
    if (!el.classList.contains('nighat-loader')) {
      el.classList.add('fade-in');
      scrollObserver.observe(el);
    }
  });
  
  
  /* ============================================
     3. SMOOTH SCROLL FOR ANCHOR LINKS
     ============================================ */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#' || targetId.length < 2) return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
  
  
  /* ============================================
     4. BACK TO TOP BUTTON (NEW)
     ============================================ */
  const backToTop = document.createElement('button');
  backToTop.className = 'nighat-back-to-top';
  backToTop.setAttribute('aria-label', 'Back to top');
  backToTop.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="20" height="20"><polyline points="18 15 12 9 6 15"/></svg>';
  document.body.appendChild(backToTop);
  
  // Back to top styles (inline to keep CSS file clean)
  Object.assign(backToTop.style, {
    position: 'fixed',
    bottom: '95px',
    left: '25px',
    width: '46px',
    height: '46px',
    borderRadius: '50%',
    background: '#1A1A1A',
    color: '#DAA520',
    border: '1.5px solid rgba(201, 162, 39, 0.4)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    visibility: 'hidden',
    transform: 'translateY(15px)',
    transition: 'all 0.35s ease',
    zIndex: '9997',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.25)'
  });
  
  // Show/hide on scroll
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 500) {
      backToTop.style.opacity = '1';
      backToTop.style.visibility = 'visible';
      backToTop.style.transform = 'translateY(0)';
    } else {
      backToTop.style.opacity = '0';
      backToTop.style.visibility = 'hidden';
      backToTop.style.transform = 'translateY(15px)';
    }
  }, { passive: true });
  
  backToTop.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  
  
  /* ============================================
     5. IMAGE LAZY LOAD ENHANCEMENT
     ============================================ */
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading supported
    document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
      img.addEventListener('load', function() {
        img.style.opacity = '1';
      });
      img.style.transition = 'opacity 0.4s ease';
    });
  }
  
  
  /* ============================================
     6. EXTERNAL LINKS - Open in new tab safely
     ============================================ */
  document.querySelectorAll('a[href^="http"]').forEach(function(link) {
    const linkHost = new URL(link.href).hostname;
    const currentHost = window.location.hostname;
    
    if (linkHost !== currentHost && !link.hostname.includes('shopify')) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
  
  
  /* ============================================
     7. MOBILE: Hide WhatsApp float when mobile bar visible
     ============================================ */
  function adjustWhatsAppPosition() {
    const waBtn = document.querySelector('.nighat-whatsapp-float');
    const mobileBar = document.querySelector('.nighat-mobile-bar');
    
    if (waBtn && mobileBar && window.innerWidth <= 749) {
      waBtn.style.bottom = '90px';
    }
  }
  
  adjustWhatsAppPosition();
  window.addEventListener('resize', adjustWhatsAppPosition);
  
  
  /* ============================================
     8. CONSOLE BRANDING
     ============================================ */
  console.log('%c✦ NIGHAT APPAREL ✦', 'color: #C9A227; font-size: 22px; font-weight: bold; font-family: serif;');
  console.log('%cLuxury Redefined — Premium Menswear Pakistan', 'color: #666; font-size: 12px;');
});
